module.exports = __webpack_public_path__ + "g.no1.b6df5b29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/g.no1.jpg
// module id = VCqA
// module chunks = 0